import { STATUS_FINANCEIRO_LABELS } from "@/modules/obras";
import { useObraEmbarcacoes, useObraLocais, useObraStatusCriacao } from "@/modules/obras";
import { readTiposObra } from "../../../hooks/nova-obra.tipos";
import { useNovaObra } from "../../../hooks/nova-obra.context";
import type { SecaoDadosObraProps } from "./types-secao-dados-obra";

export function useSecaoDadosObra({ onEditar }: SecaoDadosObraProps) {
  const { state } = useNovaObra();
  const { obra } = state;
  const embarcacoes = useObraEmbarcacoes();
  const locais = useObraLocais();
  const status = useObraStatusCriacao();
  const tipos = readTiposObra(state.etapas.tiposObra);
  const embarcacao = embarcacoes.data.find((item) => item.id === obra.embarcacaoId)?.nome;
  const local = locais.data.find((item) => item.id === obra.localPlanejadoId);
  const statusObra = status.data.find((item) => item.id === obra.statusObraId)?.descricao; // Clientes informados nos tipos (HU 2525): "Cliente deste Contrato" (comentário de 10/10).
  const clientes = [
    ...new Set(
      [...tipos.tipos, ...tipos.centrosAdicionais.flatMap((adicional) => adicional.tipos)]
        .map((tipo) => tipo.cliente.trim())
        .filter(Boolean),
    ),
  ];

  const statusFinanceiro = obra.statusFinanceiro
    ? STATUS_FINANCEIRO_LABELS[obra.statusFinanceiro]
    : "—";

  return { obra, embarcacao, local, statusObra, clientes, onEditar, statusFinanceiro };
}
